<template>
  <b-modal
      size="lg"
      id="store-promo-modal"
      :hide-header="false"
      :hide-footer="true"
      centered
      ref="storePromoModal"
      modal-class="modal-is-showing"
  >
    <template #modal-header="{ close }">
      <!-- Emulate built in modal header close button action -->
      <b-button class="promotion-modal-close" @click="close()">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.001 512.001" xml:space="preserve" fill="#ababab"><g><path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717    L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859    c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287    l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285    L284.286,256.002z"></path></g></svg>
      </b-button>
    </template>
    <!--no-close-on-backdrop vm.$refs.storePromoModal  Could attempt to use v-model to handle controlling the modal visibility, but guessing that is not the issue atm -->
    <CouponCarousel :coupons="promotion.store_coupons" :selectedSlide="slide" v-if="promotion.store_coupons.length > 0"></CouponCarousel>

   <div class="row my-2">
     <div class="col-md-6 col-sm-6 col-xs-6 text-center">
       <a href="#" class="btn btn-appointment-quote" @click="toggleQuote"><i class="fal fa-file-invoice-dollar" aria-hidden="true"></i>Get Quote</a>
     </div>
     <div class="col-md-6 col-sm-6 col-xs-6 text-center">
       <a href="#" class="btn btn-appointment-quote" @click="toggleAppointment"><i class="fal fa-file-invoice-dollar" aria-hidden="true"></i>Book Now!</a>
     </div>
   </div>
  </b-modal>
</template>
<!-- @TODO - Vertically Center Coupon Modal on Page -->
<script>
import CouponCarousel from '@/components/partials/CouponCarouselSingleView.vue'
export default {
  components: {
    CouponCarousel
  },
  props: {
    slide: Number,
    promotion: Object
  },
  data: () => {
    return {
      sliding: null,
      currentSlide: 0,
      modalVisible: false
    }
  },
  created() {

  },
  mounted(){
    //this.visibleSlide = this.slide;
    //this.$refs.promotionCarousel.setSlide(this.slide);
    const vm = this;
    this.currentSlide = this.slide;
    this.$root.$on('bv::modal::shown', function(){
      vm.$refs.storePromoModal.$refs.modal.classList.remove('modal-is-showing');
      vm.modalVisible = true;
    });
    this.$root.$on('bv::modal::hidden', function() {
      vm.modalVisible = false;
    })
  },
  computed: {
    visibleSlide: {
      get(){
        return this.currentSlide;
      },
      set(value){
        this.currentSlide = value;
      }
    },
  },
  methods: {
    hideModal(){
      this.$store.commit('CloseAllModals')
    },
    updateSlide(){
      this.visibleSlide = this.slide;
      //this.$refs.promotionCarousel.setSlide(this.visibleSlide);
    },
    toggleQuote(){
      this.$emit('toggleQuote');
    },
    toggleAppointment(){
      this.$emit('toggleAppointment');
    }
  }
}
</script>
<style>
  .carousel-control-next,.carousel-control-prev {

  }
  .modal-open #store-promo-modal {
    overflow-y: hidden;
  }
  .btn-appointment-quote {
    background-color: #ffe300;
    text-transform: uppercase;
    font-weight: bold;
  }
  .btn-appointment-quote:hover {
    color:white;
  }
  .modal-header .close {
    top: 0px;
    right: 0;
    padding: 0;
    font-size: 40px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: normal;
  }
  .modal-header {
    border-bottom:0px solid transparent;
  }
  body.modal-open {
    overflow-y: hidden;
  }
  #store-promo-modal.modal-is-showing {
    pointer-events: none !important;
  }
  #store-promo-modal .close {
    top: 0;
    right: 0;
    padding: 0;
    font-size: 2rem;
    width: 60px;
    height: 60px;
    line-height: normal;
  }
  #store-promo-modal .close::before {
    display:none !important;
  }
  #store-promo-modal .promotion-modal-close svg {
    width: 100%;
    height: 100%;
  }
  #store-promo-modal .promotion-modal-close {
    width:60px;
    height:60px;
    background-color:transparent;
    border: solid 0px transparent;
    position:absolute;
    right:0;
    top:0;
    z-index:1041;
  }
  #store-promo-modal .modal-header {
    justify-content: flex-end;
    position: relative;
    min-height:50px;
  }
</style>
